import { useState, useRef } from "react"
import Options from "./sections/Options"
import { Option, Props } from "./types"
import Label from '~components/Label'
import Error from '~components/Error'
import * as Styled from './styled'
import { useField } from "formik"
import { useOnClickOutside } from '~hooks'

const DropDown = ({
  label,
  options,
  placeholder,
  onChange,
  showError = true,
  ...props
}: Props) => {
  const [field, meta] = useField<Option>(props)
  const optionsRef = useRef<HTMLDivElement>(null)
  const [optionsOpen, setOptionsOpen] = useState(false)
  const selected = field.value
  const error = (meta.error as Option)?.value
  const hasError = !!(showError && meta.touched && error)

  useOnClickOutside(optionsRef, () => setOptionsOpen(false))

  function handleClick() {
    setOptionsOpen(open => !open)
  }

  function handleOptionClick(option: Option) {
    onChange?.(option, field.value)
    field.onChange({ target: { name: props.name, value: option } })
  }

  return (
    <Styled.Wrapper>
      <Label color={hasError ? 'danger-default' : 'neutral-strong'}>{label}</Label>
      <Styled.SelectedInput $error={hasError} $focus={optionsOpen} $selected={!!selected?.value} ref={optionsRef} onClick={handleClick}>
        {selected?.value ?
          <Styled.Selected>
            {selected.label}
          </Styled.Selected>
          :
          <Styled.Placeholder>
            {placeholder}
          </Styled.Placeholder>
        }
        <Styled.ChevronDown size="small" />
        {optionsOpen && <Options selected={selected} options={options} onOptionClick={handleOptionClick} />}
      </Styled.SelectedInput>
      {hasError && (
        <Error>
          {error}
        </Error>)}
    </Styled.Wrapper>
  )
}

export default DropDown
